<template>
  <div class="news">
    <HeaderNav :current="current" :titleMsg='titleMsg'></HeaderNav>
    <div class="news-content w1200">
      <div class="text">
        <el-breadcrumb separator-class="el-icon-arrow-right">
          <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
          <el-breadcrumb-item>证书查询</el-breadcrumb-item>
        </el-breadcrumb>
      </div>
      <div class="layout-center">
        <div class="layout-left">
          <h2 class="clum">
            <i class="icon">证书查询</i>
          </h2>
          <div class="person-bar">
            <span>证书查询结果</span>
          </div>
        </div>

        <div class="certificate-nav">
          <h2 class="person-text-title"><span>证书查询结果</span></h2>
          <div class="result-main">
            <div class="result-item">
              <span class="result-item-left">姓&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;名</span>
              <span class="result-item-right">{{resultData.data[0].userName}}</span>
            </div>
            <div class="result-item">
              <span class="result-item-left">编&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;号</span>
              <span class="result-item-right">{{resultData.data[0].certNo}}</span>
            </div>
            <div class="result-item" v-if="resultData.data[0].phoneNo !==''">
              <span class="result-item-left">电话号码</span>
              <span class="result-item-right">{{resultData.data[0].phoneNo}}</span>
            </div>
            <div class="result-item">
              <span class="result-item-left">类&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;型</span>
              <span class="result-item-right">{{resultData.data[0].projectName}}</span>
            </div>
            <div class="result-item">
              <span class="result-item-left">证书名称</span>
              <span class="result-item-right">{{resultData.data[0].certName}}</span>
            </div>
            <div class="result-item">
              <span class="result-item-left">发证日期 </span>
              <span class="result-item-right">{{formatDate(resultData.data[0].issueTime)}}</span>
            </div>
            <div class="result-item" v-if="resultData.data[0].idNo !==''">
              <span class="result-item-left">身份证号</span>
              <span class="result-item-right">{{resultData.data[0].idNo}}</span>
            </div>
            <div class="result-item">
              <span class="result-item-left">协会名称</span>
              <span class="result-item-right">{{resultData.data[0].assoName}}</span>
            </div>
            <div class="result-item">
              <span class="result-item-left">单位名称</span>
              <span class="result-item-right">{{resultData.data[0].memberName}}</span>
            </div>
          </div>
          <!-- <CateTemplate v-if="isPersone"></CateTemplate> -->
          <div class="submit-btn">
              <el-button type="primary" @click="backGetCertificate()">返回</el-button>
            </div>
        </div>
      </div>
    </div>
    <CopyRight></CopyRight>

  </div>
</template>

<script>
import HeaderNav from '@/components/common/HeaderNav/HeaderNav'

import CopyRight from '@/components/common/CopyRight/CopyRight'
import CateTemplate from '@/components/common/UserCenter/CateTemplate'
import {formatDate} from '@/components/common/config/formatTime.js'
export default {
  name: 'PersonalCertificate',
  components: {
    HeaderNav,
    CopyRight,
    CateTemplate
  },
  data () {
    return {
      current: 3,
      isPersone: false,
      input: '',
      name: '',
      certificateNumStr: '',
      titleMsg: '证书查询',
      resultData: JSON.parse(localStorage.getItem('resultData'))
    }
  },
  methods: {
    formatDate,
    backGetCertificate () {
      localStorage.removeItem('resultData')
      this.$router.push({
        name: 'PersonalCertificate'
      })
    }
  },
  mounted () {

  },
  created () {
    console.log(this.resultData)
    if (this.resultData.data[0].projectName === '级位证') {
      this.isPersone = true
    } else {
      this.isPersone = false
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
  .news {
    width: 100%;
    background-color: #fff;
  }

  .news-content {
    width: 1100px;
    padding: 20px 50px 50px 50px;
    background: #f3f3f3;
    border-radius: 10px;
    margin-top: 20px;
    min-height: 580px;
  }
  .layout-center{
    overflow: hidden;
  }
  .layout-left{
    width: 110px;
    float: left;
    margin-right: 40px;
  }
  .certificate-nav{
    float: left;
    width: 950px;
  }
  .person-text-title{
    padding: 30px 0px;
    text-align: center
  }
  .person-text-title span{
    background: url(../../../static/images/ge-ren.png)0px center no-repeat;
    background-size: 20px 20px;
    padding: 10px 0px 10px 25px;
    font-size: 16px;
  }
  .news-content .clum {
    overflow: hidden;
    padding: 20px 0px;
  }

  .news-content .clum .icon {
    display: inline-block;
    font-size: 20px;
    background-position: 0px center;
    background-repeat: no-repeat;
    font-weight: 500;
    background-size: 5px 20px;
    background-image: url(../../../static/images/nwe-shuxian.png);
    padding-left: 14px;
    font-style: normal;
    color: #999;
  }

  .news-content .clum span {
    float: right;
    font-size: 16px;
    color: #888;
    line-height: 30px;
    cursor: pointer;
  }
  .person-bar{
    width: 94px;
  }
  .submit-btn{
    width: 100%;
    text-align: center;
    margin-top: 20px;
  }
  .submit-btn .el-button{
    background: #cc0000;
    color: #fff;
    border-color: #cc0000;
    padding: 10px 20px;
  }
  .person-bar span{
    font-size: 14px;
    color:#fff;
    background: #cc0000;
    border-radius: 5px;
    width: 94px;
    padding: 5px 0px;
    display: block;
    text-align: center
  }
  .result-main{
    width: 400px;
    margin: 0px auto;
    padding-bottom: 20px;
  }
  .result-item{
    overflow: hidden;
    margin-bottom: 10px;
  }
  .result-item-left{
    float: left;
    width: 80px;
    padding: 5px 0px;
    font-size: 14px;
  }
  .result-item-right{
    float: right;
    background: #fff;
    width: 300px;
    padding: 5px;
    font-size: 14px;
    border-radius: 5px;
  }
  .text {
    border-radius: 5px;
    background: #fff;
    margin-top: 30px;
    padding:15px 10px;
    border-bottom: 0px;
  }
  .text p {
    font-size: 14px;
    color:#888;
    padding: 15px;
  }
  .demo-table-expand {
    font-size: 0;
  }
  .demo-table-expand label {
    width: 90px;
    color: #99a9bf;
  }
  .demo-table-expand .el-form-item {
    margin-right: 0;
    margin-bottom: 0;
    width: 50%;
  }
  .seach{
    width: 100%;
    margin-bottom: 5px;
  }
  .seach .el-input{
    width: 300px;
  }
  .el-button{
    background: #cc0000;
    color: #fff;
  }
  .fixd {
    width: 100%;
    position: fixed;
    bottom: 0px;
    left: 0px;
  }
</style>



// WEBPACK FOOTER //
// src/components/pages/QueryResult.vue